const STRINGS = {
  es: {
    COPY: 'Copiar',
    COPIED: '¡Copiado!',
  },
  pt: {
    COPY: 'Copiar',
    COPIED: 'Copiado!',
  },
};

export default STRINGS;
